import Store from '../../helpers/store';

export default class SubstanceClassesStore extends Store {
}


// WEBPACK FOOTER //
// ./js/models/antibiotics/substanceClassesStore.js